module.exports = __webpack_public_path__ + "img/footer_background_opt.d09ef27a.jpg";